import { useIntl } from 'react-intl';

export const useTranslation = () => {
  const { formatMessage } = useIntl();

  return (id: string) => formatMessage({ id });
};
